import type { IAiRecommendations } from '@model/aiRecommendations';

import type { IRecommendation } from '../model/recommendation';

const REPORT_RECOMMENDATION: { [key: number]: string } = {
  1: 'Minor',
  2: 'Moderate',
  3: 'Severe',
  4: 'Extreme',
};

export const actionItemRecommendationsSelect = (
  recommendations: IAiRecommendations[],
  t: (text: string, fields?: unknown, isMatch?: boolean) => string,
) => {
  if (!recommendations?.length) return { list: [], info: [''] };

  const list: IRecommendation[] = [];
  const indexObj: { [key: string]: number } = {};
  const faultsMap = new Map();
  const sortedRecommendations = [...recommendations].sort((a, b) => b.severity - a.severity);
  const info: string[] = [];

  sortedRecommendations.forEach(({ component_type, fault, recommendation, severity }) => {
    const key = `${component_type?.id || 0}-${fault?.id || 0}`;

    if (faultsMap.has(key)) {
      const fault = faultsMap.get(key);
      faultsMap.set(key, { ...fault, text: `${fault.text}, ${t(recommendation.name)}` });
    } else {
      faultsMap.set(key, {
        typeName: component_type?.name || 'Generic Recommendations',
        label: t(fault?.name || 'All'),
        text: t(recommendation.name),
        severity: t(REPORT_RECOMMENDATION[severity]),
      });
    }
  });

  faultsMap.forEach((fault) => {
    if (indexObj.hasOwnProperty(fault.typeName)) {
      list[indexObj[fault.typeName]]['faults'].push(fault);
    } else {
      indexObj[fault.typeName] = list.length;
      list.push({ label: t(fault.typeName), faults: [fault] });
    }
  });

  list.forEach((item) => {
    item.faults.forEach((fault) => {
      info.push(`${t('Component type')}: ${item.label}`);
      info.push(`${t('Fault Name')}: ${fault.label}`);
      info.push(`${t('Recommendations')}: ${fault.text}`);
      info.push(`${t("Fault's Severity")}: ${fault.severity}`);
      info.push('');
    });
  });

  return { list, info };
};
